import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthenticationUtils } from './authentication.utils';
import { AuthenticatorService } from 'idk/services/security/authenticator.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthenticatorService) {}

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = req.clone();

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                // Catch "401 Unauthorized" responses
                if (
                    error instanceof HttpErrorResponse &&
                    error.status === 401
                ) {
                    // Sign out
                    this._authService.signOut().subscribe();

                    // Reload the app
                    // location.reload();
                }

                return throwError(() => error);
            })
        );
    }
}
